import { DonationItem } from '@/types/donation-item'

export const getDonationSpecification = (
  items?: DonationItem[]
): string | undefined => {
  if (!items || items.length === 0) return undefined

  const counts = new Map<string, number>()

  for (const item of items) {
    const name = item.name ?? 'Unknown'
    counts.set(name, (counts.get(name) ?? 0) + 1)
  }

  return Array.from(counts.entries())
    .map(([name, count]) => (count > 1 ? `${count} x ${name}` : name))
    .join(', ')
}
